<template>
  <div :class="['card testimony', { checked : comment.save_comment } ]">
    <div class="card-body">
      <p class="text-left mb-2 name-testimonyal">
        <img
          :src="normalizeUrlAvatar(comment.picture)"
          alt
          class="testimonial-avatar rounded-circle"
        />
        <span class="comment-name">{{ comment.name }}</span>
      </p>
      <p class="text-testimonyal" v-html="comment.text"></p>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "testimony",
  props: {
    comment: {
      required: false,
    },
  },
  methods: {
    normalizeUrlAvatar,
  },
};
function normalizeUrlAvatar(picture) {
  return process.env.CDN_URL + picture;
}
</script>
<style scoped>
.comment-name {
  font-size: 12px;
}
.testimony.card {
  margin: 7px 0 8px 0px;
  padding: 0;
  box-shadow: 0 0 7px 0px #00000012;
  cursor: pointer;
  border: 1px solid transparent;
  transition: all 0.3s;
}
.testimony .card-body {
  padding: 10px;
}
.name-testimonyal {
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
  font-size: 12px;
}
.text-testimonyal {
  font-size: 12px;
  text-align: left;
  margin: 0;
}
.testimonial-avatar {
  width: 31px !important;
  height: 31px !important;
  margin-right: 8px;
}
.card.testimony.checked {
  border: 1px solid var(--main-color);
}
.checked::after {
  font-size: 1.31rem;
  font-family: "Font Awesome 5 Pro";
  font-weight: 900;
  content: "\f058";
  color: var(--main-color);
  background-color: #fff;
  position: absolute;
  right: 10px;
  top: 6px;
}
@media screen and (min-width: 998px) {
  .testimony .card-body {
    padding: 18px;
  }
  .text-testimonyal {
    font-size: 14px;
  }
  .name-testimonyal {
    font-weight: 700;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Testimony.vue